import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ReactComponent as XmarkIcon } from '../../../icons/xmark.svg';

import './CloseButton.scss';

// The dismiss button every modal and sheet shares: an accent X in a gray circle
const CloseButton = ({ onClick, className = '', label, ...rest }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={classNames('CloseButton', className)}
      onClick={onClick}
      aria-label={label || t('common.close')}
      {...rest}
    >
      <XmarkIcon aria-hidden="true" />
    </button>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default CloseButton;
